import FoundationFinder from 'pages/FoundationFinder/index';
import {
  Product,
  SearchAutoSuggestions,
  Home,
  NotFound,
  CategoryListing,
  SearchListing,
  OfferProductListing,
  // Redirection,
  Fitcode,
  ProIntro,
  ProRegistration,
  AllReview,
  Landing,
  CMS,
  StoresNEvents,
  MyProfile,
  VideoConsultation,
  PricesRevealed,
  PredictAndWin,
  Wishlist,
  Offline,
  Auth,
  Hlp,
  BPCategory,
  BPLanding,
  Games,
  CouponOffers,
  BestSeller,
  AllReviewImages,
  ShoppingBag,
  ConvSearchListing,
  SelectDeliveryLocationPage,
  DualTabConvSearch,
} from '../pages';
import { Loyalty } from '../User/pages';

const routes = [
  {
    path: '/:slug/p/:id',
    component: Product,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: ['/', '/home'],
    component: Home,
    header: true,
    footer: true,
    exact: true,
    scroll: true,
    bottomNav: true,
  },
  {
    path: '/:url*/c/:id',
    component: CategoryListing,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: '/search/query',
    component: SearchAutoSuggestions,
  },
  {
    path: '/:slug/review-images/:id',
    component: AllReviewImages,
    header: false,
    footer: false,
    scroll: true,
  },
  {
    path: ['/search/result', '/src/:slug', '/dp/:slug'],
    component: SearchListing,
    header: true,
    footer: true,
    exact: true,
    scroll: false,
  },
  {
    path: '/:url*/offer-products/:id',
    component: OfferProductListing,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: '/fitcode/result',
    component: Fitcode,
    exact: true,
  },
  {
    path: '/pro-intro',
    component: ProIntro,
    header: true,
    footer: false,
    exact: true,
    scroll: true,
  },
  {
    path: '/nykaa-pro-sign-up',
    component: ProRegistration,
    header: true,
    footer: true,
    exact: true,
    scroll: true,
  },
  {
    path: '/wishlist/',
    component: Wishlist,
    header: true,
    footer: true,
    scroll: true,
  },
  {
    path: ['/shoppingBag'],
    component: ShoppingBag,
    header: false,
    footer: false,
    scroll: true,
  },
  {
    path: ['/:slug/reviews/:id'],
    component: AllReview,
    header: false,
    footer: false,
    scroll: true,
  },
  {
    path: ['/sp/:id/:pageData?'],
    component: Landing,
    header: true,
    footer: true,
    scroll: true,
    bottomNav: true,
  },
  {
    path: ['/video-consultation'],
    component: VideoConsultation,
    header: false,
    footer: false,
    scroll: true,
  },
  {
    path: '/:slug/lp',
    component: CMS,
    header: true,
    footer: true,
    scroll: true,
  },
  {
    path: '/myProfile',
    component: MyProfile,
    header: false,
    footer: false,
    scroll: true,
    bottomNav: true,
  },
  {
    path: '/auth',
    component: Auth,
    header: false,
    footer: false,
    scroll: false,
  },
  {
    path: '/prive',
    component: Loyalty,
    header: false,
    footer: false,
    exact: false,
    routes: ['/coupon-list', '/reward-list'],
  },
  {
    path: [
      '/:saleId/prices-revealed',
      '/:saleId/prices-revealed/:nonCoreCategory',
    ],
    component: PricesRevealed,
    exact: true,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: '/pnw/predict-and-win',
    component: PredictAndWin,
    header: false,
    footer: false,
    exact: false,
  },
  {
    path: '/stores-n-events-msite',
    component: StoresNEvents,
    header: false,
    footer: false,
    scroll: false,
    routes: ['/all-stores'],
  },
  {
    path: '/portfolio/destination',
    component: BPLanding,
    header: false,
    footer: false,
    scroll: false,
  },
  {
    path: '/portfolio/:category',
    component: BPCategory,
    header: false,
    footer: false,
    scroll: false,
  },
  {
    path: '/coupons-offers',
    component: CouponOffers,
    header: false,
    footer: false,
    scroll: false,
  },
  {
    path: '/offline',
    component: Offline,
    header: false,
    footer: false,
    scroll: false,
  },
  {
    path: '/hlp/:id',
    component: Hlp,
    header: true,
    footer: true,
    scroll: true,
  },
  {
    path: '/:slug/top-bestsellers-ranked/:id',
    component: BestSeller,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: ['/cp/:slug'],
    component: Games,
    exact: true,
    header: true,
    footer: true,
    scroll: false,
  },
  {
    path: ['/search/conversation'],
    component: ConvSearchListing,
    header: false,
    footer: false,
    exact: true,
    scroll: false,
  },
  {
    path: ['/foundation-finder'],
    component: FoundationFinder,
    header: false,
    footer: false,
    exact: true,
    scroll: false,
  },
  {
    path: '/select-delivery-location',
    component: SelectDeliveryLocationPage,
    header: false,
    footer: false,
    scroll: false,
    exact: true,
  },
  {
    path: ['/ai-conversation'],
    component: DualTabConvSearch,
    header: false,
    footer: false,
    exact: true,
    scroll: false,
  },
  {
    path: '*',
    component: NotFound,
    status: 404,
  },
];

export default routes;
